import React from "react";

const Footer = () => {
  return (
    <div className="bg-[#600924]">
      <div className="lg:px-28 max-lg:px-10 lg:pt-16 max-lg:pt-10">
        <div className="lg:flex lg:justify-between">
          <div className="lg:w-2/5">
            <img
              className="w-[150px] h-auto"
              src="/assets/logo-vishwa-sanatan.svg"
              alt="Logo Icon"
            />
            <p className="mt-10 font-inter text-sm lg:w-4/6 text-white font-light">
            विश्व सनातन महापीठ
जहाँ से सनातन का सूर्य पुनः उदित होता है,  सत्य, सेवा और संस्कार से जगत को आलोकित करने हेतु।
        यहाँ सनातन केवल स्मृति नहीं - एक जीवित प्रकाश है।

            </p>
          </div>
          <div className="lg:w-3/5">
            <div className="lg:flex lg:justify-between text-white">
              <div className="max-lg:mt-10 max-lg:text-center">
                <p className="font-inter text-xl font-semibold">Useful Link</p>
                <ul className="text-sm font-inter font-light mt-7">
                  <li><a href="/" className="hover:text-[#B51F3B] transition-colors">Home</a></li>
                  <li className="mt-5"><a href="/?page=about" className="hover:text-[#B51F3B] transition-colors">About Us</a></li>
                  <li className="mt-5"><a href="/?page=events" className="hover:text-[#B51F3B] transition-colors">Events</a></li>
                  <li className="mt-5"><a href="/?page=contact" className="hover:text-[#B51F3B] transition-colors">Contact Us</a></li>
                  <li className="mt-5"><a href="/?page=terms" className="hover:text-[#B51F3B] transition-colors">Terms & Conditions</a></li>
                  <li className="mt-5"><a href="/?page=privacy" className="hover:text-[#B51F3B] transition-colors">Privacy Policy</a></li>
                  <li className="mt-5"><a href="/?page=refund" className="hover:text-[#B51F3B] transition-colors">Refund Policy</a></li>
                </ul>
              </div>

              <div className="max-lg:mt-10 max-lg:text-center">
                <p className="font-inter text-xl font-semibold">Contact Info</p>
                <ul className="text-sm font-inter font-light mt-7 lg:w-[200px]">
                  <li className="flex max-lg:justify-center gap-3">
                    {" "}
                    <img
                      src="/assets/location-icon.svg"
                      alt="loc"
                    />
                    तीर्थ आश्रम, शिवलोक कॉलोनी, भगत सिंह चौराहे के पास, हरिद्वार, उत्तराखंड - 249401
                  </li>
                  {/* <li className="flex max-lg:justify-center gap-3 mt-8">
                    {" "}
                    <img
                      src="/assets/email-icon.svg"
                      alt="loc"
                    />{" "}
                    georgepwright@jourrapide.com
                  </li> */}
                  <li className="flex max-lg:justify-center gap-3 mt-8">
                    <img
                      src="/assets/phone-icon.svg"
                      alt="loc"
                    />{" "}
                    9520050068<br/>
                    9520050038
                  </li>
                </ul>
              </div>

              <div className="max-lg:mt-10 max-lg:text-center">
                <p className="font-inter text-xl font-semibold">Social Media</p>
                <ul className="text-sm font-inter font-light mt-7">
                  <li><a href="https://www.facebook.com/share/1AVFg6W3SA/" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                  <li className="mt-5"><a href="https://www.instagram.com/vsmahapeeth" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                  {/* <li className="mt-5">Youtube</li>
                  <li className="mt-5">X</li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr className="mt-20 pb-4" />

        {/* Compliance Information */}
        <div className="pb-4 font-inter text-sm text-white">
          <p className="mb-2">
            © 2025. Teerth Sewa Nyas
          </p>
          {/* <p className="text-xs text-gray-300">
            Payments processed by Teerth Sewa Nyas | All donations are tax-deductible under Section 80G
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
